import {
  initialState,
  Actions,
  State,
  GET_COMMUNITY_POSTS,
  GET_COMMUNITY_POSTS_SUCCESS,
  GET_COMMUNITY_POSTS_ERROR,
} from "../../types/community/posts";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_COMMUNITY_POSTS:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_COMMUNITY_POSTS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_COMMUNITY_POSTS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
